import React, { ReactElement, ReactNode } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./components/login/login";
import PrivateRoute from "./core/privateRoute";
import ForgotPassword from "./components/forgotPassword/forgotPassword";
import ResetPassword from "./components/resetPassword/resetPassword";
import MainLayout from "./components/layout/MainLayout";
import MyProfile from "./pages/myprofile/MyProfile";

type AppRouterProps = {
  isLoggedIn: boolean;
  allowedRoutes: ReactNode;
  indexElement: ReactElement;
};

const AppRouter = (props: AppRouterProps) => {
  const { isLoggedIn, allowedRoutes, indexElement } = props;

  return (
    <Routes>
      <Route
        path="/login"
        element={isLoggedIn ? <Navigate to="/" /> : <Login />}
      />
      <Route
        path="/forgot-password"
        element={isLoggedIn ? <Navigate to="/" /> : <ForgotPassword />}
      />
      <Route
        path="/reset-password"
        element={<ResetPassword />}
      />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/" element={<MainLayout />}>
          <Route index element={indexElement} />
          <Route path="/profile" element={<MyProfile />} />
          {allowedRoutes}
        </Route>
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
};

export default AppRouter;
